// assets/custom-add-to-cart.js
(function () {
  // Announcer for screen readers
  let live = document.getElementById('cart-live');
  if (!live) {
    live = document.createElement('div');
    live.id = 'cart-live';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.style.position = 'absolute';
    live.style.left = '-9999px';
    document.body.appendChild(live);
  }

  // Top/bottom bar confirmation (no popup/drawer)
  function ensureBar() {
    let bar = document.getElementById('cart-add-bar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'cart-add-bar';
    bar.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:25px;display:flex;gap:8px;align-items:center;padding:10px 14px;background:var(--color-button-primary);color:#fff;border-radius:30px;z-index:9999;box-shadow:0 6px 20px rgba(0,0,0,.25);font-size:14px';
    bar.innerHTML = `
      <span id="cart-add-msg">Đã thêm vào giỏ hàng.</span>
      <a href="/cart" style="text-decoration:none;padding:8px 10px;background:#fff;color:#000;border-radius:30px">Xem giỏ hàng</a>
    `;
    document.body.appendChild(bar);
    setTimeout(() => { bar.style.opacity = '1'; }, 0);
    setTimeout(() => { bar.remove(); }, 2600);
    return bar;
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });
  }

  async function fetchCartCount() {
    const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await res.json();
    updateCartCount(cart.item_count);
  }

  async function addToCartViaForm(form) {
    const formData = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.description || 'Add to cart failed');
    }
  }

  // Intercept all product forms that post to /cart/add
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    // Respect Cmd/Ctrl submit for power users
    if (e.metaKey || e.ctrlKey) return;

    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn && btn.textContent;

    try {
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      await addToCartViaForm(form);
      await fetchCartCount();
      ensureBar();
      live.textContent = 'Added to cart.';
    } catch (error) {
      console.error(error);
      // If it failed (e.g., no variant selected), fall back to native submit so theme shows errors
      form.submit();
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  });

  // Optional: quick-add buttons in collection grids (add data-quick-add-variant-id on the button)
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add-variant-id]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.getAttribute('data-quick-add-variant-id');
    const qty = Number(btn.getAttribute('data-qty') || 1);

    try {
      btn.disabled = true;
      btn.textContent = 'Adding…';
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity: qty })
      });
      if (!res.ok) throw new Error('Quick add failed');
      await fetchCartCount();
      ensureBar();
      live.textContent = 'Added to cart.';
    } catch (err) {
      console.error(err);
      // Fallback: go to product page if provided
      const href = btn.getAttribute('href');
      if (href) window.location.href = href;
    } finally {
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-original-label') || 'Add';
    }
  });
})();
